/**
 * Shared bits for "which bookings used a coupon".
 *
 * The coupon code is stored inside the reservation's coupon JSON, so filtering by it needs the
 * `coupon => jsonCouponData` entry in ReservationAdapter::getFieldMapping() on the server. A filter
 * field the adapter does not know is SILENTLY DROPPED (OrmAdapter, `if ($field != null)`), which
 * would show every reservation while the UI claims a coupon filter is active — worse than having no
 * filter at all. booking/website has no auto-deploy, so the PHP file is uploaded by hand.
 *
 * This is now on, and the reservations list no longer takes the server's word for it: every row
 * carries its coupon code, so if the returned rows don't match what was asked for, the page says the
 * filter was ignored instead of passing an unfiltered list off as a filtered one. That makes the
 * flag safe even if the server is ever rolled back to a build without the mapping.
 *
 * The coupon TAG on the reservation rows does not depend on any of this: the code is already on
 * every row, so it works regardless.
 */
export const COUPON_FILTER_READY = true

/** Sentinel for "any coupon at all" — not a valid code, so it cannot collide with a real one. */
export const ANY_COUPON = '*'

/** URL param that deep-links the reservations list to one coupon (from the Coupon page). */
export const COUPON_PARAM = 'coupon'
